<template>
  <div>
    <v-edit-dialog
        v-if="!!labels && !disabledBtn"
        @save="$emit('click')"
        :save-text="labels.confirm"
        :cancel-text="labels.cancel"
        large
    >
      <v-row no-gutters class="flex-nowrap my-4">
        <v-icon :loading="loadingIcon">{{labels.icon}}</v-icon>
        <span class="ml-2">{{labels.btn}}</span>
      </v-row>
      <template v-slot:input>
        <v-sheet class="mt-5">
          {{labels.text}}
        </v-sheet>
      </template>
    </v-edit-dialog>
    <v-row
        v-if="disabledBtn"
        no-gutters
        class="flex-nowrap my-4"
    >
        <v-icon :loading="loadingIcon" disabled>{{labels.icon}}</v-icon>
        <span class="ml-2" disabled>{{labels.btn}}</span>
      </v-row>
  </div>
</template>

<script>

export default {
  name: 'BaseConfirmBtn',
  inheritAttrs: false,
  props: {
    labels: {default: null},
    loading: {type:[Boolean], default: false},
    disabled: {default: false},
  //   {
  //       btn: 'Action',
  //       icon: 'mdi-delete',
  //       confirm: 'Agree',
  //       cancel: 'Cancel',
  //       text: 'Are you sure?',
  //     }
  },

  components: {},

  computed: {},

  watch: {
    disabled: {
      handler(newValue, oldValue) {
        // console.log('watch', newValue, oldValue)
        this.disabledBtn = newValue
      },
      deep: false
    },
    loading: {
      handler(newValue, oldValue) {
        // console.log('watch', newValue, oldValue)
        this.loadingIcon = newValue
      },
      deep: false
    },
  },

  methods: {
  },

  async mounted() {
    // this.deleted = this.value
  },

  data() {
    return {
      disabledBtn: this.disabled,
      loadingIcon: this.loading,
    }
  }
}
</script>

<style scoped lang="scss">
.no-spin input[type='number'] {
  -moz-appearance: textfield;
  /*width: 50px;*/
}

</style>

<i18n>
{
  "en": {
    "are_you_sure": "Are you sure?",
    "cancel": "Cancel",
    "restore": "Restore",
    "delete": "Delete",
    "delete_message": "Do you want to delete? Are you sure?",
    "restore_message": "Do you want to restore? Are you sure?"
  },
  "de": {
    "are_you_sure": "Bist du sicher?",
    "cancel": "Stornieren",
    "restore": "Wiederherstellen",
    "delete": "löschen",
    "delete_message": "Möchten Sie löschen? Bist du dir sicher?",
    "restore_message": "Möchten Sie wiederherstellen? Bist du dir sicher?"
  }
}
</i18n>
